import React from 'react';
import { Box, Typography } from '@mui/material';
import "./CustomNodes/CustomNodes.css";
import { useTranslation } from 'react-i18next';

const LeftPanel = () => {
  const { t } = useTranslation();

  const ICON_TYPES = {
    "GET_DATA": t("GET_DATA"),
    "TRANSLATE": t("TRANSLATE"),
    "SEND_DATA": t("SEND_DATA"),
    "VARIABLE_ITEM": t("TIT_VARIABLE"),
    "LOOP_ITEM": t("LOOP_ITEM"),
    "CONDITION_IF": "IF",
    "CONDITION_ELSE": "ELSE",
    "CALL_PLUGIN": t("CALL_PLUGIN"),
    "CALL_WORKFLOW": t("CALL_WORKFLOW"),
    "TRADING_PARTNER_LOOKUP": "TP Lookup",
    "ACTION_ITEM": t("ACTION"),
    "COMMENT": t("COMMENT"),
    "ERROR_HANDLER": t("ERROR_HANDLER"),
    "TRACKING_REPORT_ITEM": t("TRACKING_REPORT_ITEM"),
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4, backgroundColor: 'white', 
      overflowY: 'scroll',
      maxHeight: 'calc(100vh - 106px)',
      padding: "32px 15px",
      width: 'fit-content',
      border: '2px solid #c1c1c1'
     }}>
      {
        Object.keys(ICON_TYPES).map((icon) => (
          <Box 
          key={icon} 
          sx={{ display: 'flex', alignItems: 'center', gap: 1, flexDirection: 'column', cursor: 'grab', background: 'transparent' }}
          draggable 
          onDragStart={(e) => {
            e.dataTransfer.setData("application/reactflow", icon);
            e.dataTransfer.effectAllowed = "move";
          }}>
            <span className={icon+"_NEW"}></span>
            <Typography sx={{ whiteSpace: 'nowrap' }}>{ICON_TYPES[icon]}</Typography>
          </Box>
        ))
      }
    </Box>
  )
}

export default LeftPanel;